import React from 'react';

import { Grid } from '@material-ui/core';

import { SearchBar, VideoDetail, VideoList } from './components';

import youtube from './api/youtube';

class App extends React.Component{

  state = {
    videos: [],
    selectedVideo: null,
  }
   
  componentDidMount(){
    this.handleSubmit('Pewdiepie')
  }
  onVideoSelect = (video) => {
    this.setState({selectedVideo: video});
  }
  
  handleSubmit = async (searchTerm) => {
    const response = await youtube.get('search', {
      params: {
        part: 'snippet',
        maxResults: 5,
        key: 'AIzaSyDM8DipAKyPMzpKvswAsKHjD8pOSTNsX1U',
        q: searchTerm,         
      }
    });
    console.log(response);
    this.setState({videos: response.data.items, selectedVideo: response.data.items[0] });
  }


  render(){

    const { selectedVideo, videos } = this.state;

    return(
      <Grid justify="center"  container spacing={8}>
        <Grid item xs={12}>
          <Grid container spacing={8}>
            <Grid item xs={8}>
              <SearchBar onFormSubmit={this.handleSubmit}></SearchBar>
            </Grid>
            <Grid item xs={8}>
              <VideoDetail video={selectedVideo}></VideoDetail>
            </Grid>
            <Grid item xs={4}>
              <VideoList videos={videos} onVideoSelect={this.onVideoSelect}></VideoList>
            </Grid>                        
          </Grid>
        </Grid>
      </Grid>



    )
  }
}
export default App;
